<mbs-modal
  #modal
  [bodyClasses]="'p-0 max-hv-75 w-100 overflow-x-hidden'"
  [isCustomModal]="true"
  [responsive]="true"
  [showFooter]="true">
  <ng-container modal-header>
    <span [innerHTML]="'shared:sendLogs.title.reportProblem' | i18next: { name: computerName }"></span>
  </ng-container>

  <ng-container modal-body>
    <form
      class="mbs-form"
      [formGroup]="formGroup">
      <fieldset class="mbs-form_content">
        <!-- Top Block -->
        <div
          class="px-4 pt-4"
          id="top-block">
          @if (initialErrorData) {
            <mbs-alert
              [icon]="true"
              [type]="MbsPopupType.danger">
              <div class="d-flex align-items-center justify-content-between w-100">
                <span class="font-weight-bold">{{ initialErrorData.title || ('shared:sendLogs.alert.errorDetails' | i18next) }}</span>
                <mbs-button
                  type="dark"
                  [isCtrl]="true"
                  [size]="mbsSize.xs"
                  (click)="expandPlanDetailClickHandler()">
                  <span
                    class="fa"
                    [class.fa-chevron-down]="isHideErrorDetail"
                    [class.fa-chevron-up]="!isHideErrorDetail"></span>
                </mbs-button>
              </div>
              <span [ngbCollapse]="isHideErrorDetail">{{ initialErrorData.message }}</span>
            </mbs-alert>
          }

          <ng-container formGroupName="params">
            <mbs-form-group
              [title]="'shared:sendLogs.label.sendLogs' | i18next"
              [titleClasses]="'mb-1 font-weight-bold'">
              @if (!('Readonly' | can: 'read')) {
                <mbs-checkbox
                  formControlName="sendToSupport"
                  [descriptionClasses]="initialErrorData ? 'mt-0' : 'mt-2'"
                  [descriptionOutside]="false"
                  [label]="'shared:sendLogs.label.toSupport' | i18next"
                  (change)="handleChangeToSupport($event)">
                  <ng-template
                    checkboxDescription
                    [hide]="!formGroup.get('params.sendToSupport').value">
                    @if (initialErrorData && !('SendTicketsOnlyToSupportEmail' | can: 'read')) {
                      <span class="text-xs">
                        {{ 'shared:sendLogs.label.toSupportEmail' | i18next }}
                      </span>
                    }

                    @if (!initialErrorData && ('SuperAdmin' | can: 'read')) {
                      <mbs-alert
                        [icon]="true"
                        [type]="MbsPopupType.warning">
                        {{ 'shared:sendLogs.alert.sendLogsForSuperAdmin' | i18next }}
                      </mbs-alert>
                    }

                    @if (!initialErrorData) {
                      <mbs-alert
                        #alertElementRef
                        class="mb-0"
                        [icon]="true"
                        [type]="MbsPopupType.info">
                        @if (
                          ('SendTicketsOnlyToSupportEmail' | can: 'read') ||
                          (('SubAdmin' | can: 'read') && !('HelpMarketing' | can: 'read'))
                        ) {
                          {{ 'shared:sendLogs.alert.noHelpMarketing' | i18next: { format: 'capitalize' } }}
                        } @else {
                          {{ 'shared:sendLogs.alert.text_start' | i18next: { format: 'capitalize' } }}
                          <mbs-button
                            [isCtrl]="true"
                            [size]="mbsSize.md"
                            (click)="handleRedirectToSP()">
                            {{ 'shared:sendLogs.alert.supportPortal' | i18next: { format: 'title' } }} </mbs-button
                          >.
                          {{ 'shared:sendLogs.alert.text_end' | i18next: { format: 'capitalize' } }}

                          <a
                            href="https://www.msp360.com/download/MSP360-customer-support-reference-guide.pdf"
                            target="_blank">
                            {{ 'shared:sendLogs.alert.link' | i18next: { format: 'title' } }}
                          </a>
                        }
                      </mbs-alert>
                    }
                  </ng-template>
                </mbs-checkbox>
              }

              @if (!('Readonly' | can: 'read')) {
                <mbs-checkbox
                  formControlName="sendToCustomEmail"
                  [checked]="false"
                  [descriptionOutside]="false"
                  [label]="'shared:sendLogs.label.toEmail' | i18next">
                  <ng-template checkboxDescription>
                    <mbs-input
                      class="mt-2 d-block"
                      formControlName="customEmails"
                      [container]="'body'"
                      [disabledSelf]="!formGroup.get('params.sendToCustomEmail').value"
                      [ngbTooltip]="placeholderText"
                      [placeholder]="placeholderText"
                      [placement]="'auto'"
                      [tooltipClass]="'tooltip-lg'"></mbs-input>
                  </ng-template>
                </mbs-checkbox>
              }
            </mbs-form-group>
          </ng-container>

          @if (!isLastRunInfo && computer && isAnyAgentSelectable) {
            <mbs-form-group [title]="'shared:sendLogs.title.selectAgent' | i18next">
              <div [class.row]="canSendEventLogs">
                <div
                  [class.col-4]="canSendEventLogs"
                  [class.row]="!canSendEventLogs">
                  <ng-container formGroupName="agentCommands">
                    @if (PermissionsEnum.Backup | can: 'read') {
                      <div
                        [class.col-3]="!canSendEventLogs"
                        [class.row]="canSendEventLogs">
                        <mbs-checkbox
                          formControlName="backup"
                          [disabledSelf]="!isAgentAvailable(AgentType.Backup)"
                          [label]="'shared:products.backup' | i18next"
                          (change)="handleChangeIncludeEventLogs($event)"></mbs-checkbox>
                      </div>
                    }

                    @if (PermissionsEnum.Rmm | can: 'read') {
                      <div
                        [class.col-3]="!canSendEventLogs"
                        [class.mt-2]="canSendEventLogs"
                        [class.row]="canSendEventLogs">
                        <mbs-checkbox
                          formControlName="rmm"
                          [disabledSelf]="!isAgentAvailable(AgentType.RMM)"
                          [label]="'shared:products.rmm' | i18next"></mbs-checkbox>
                      </div>
                    }

                    @if (PermissionsEnum.ShowRemoteConnection | can: 'read') {
                      <div
                        [class.col-4]="!canSendEventLogs"
                        [class.mt-2]="canSendEventLogs"
                        [class.row]="canSendEventLogs">
                        <mbs-checkbox
                          formControlName="ra"
                          [disabledSelf]="!isAgentAvailable(AgentType.RA)"
                          [label]="'shared:products.remote_desktop' | i18next"></mbs-checkbox>
                      </div>
                    }
                  </ng-container>
                </div>
                <div class="col-8">
                  @if (canSendEventLogs) {
                    <mbs-form-group>
                      <mbs-checkbox
                        formControlName="includeEventLogs"
                        [disabledSelf]="!formGroup.get('agentCommands.backup').value"
                        [label]="'shared:sendLogs.label.includeEvent' | i18next: { format: 'capitalize' }"></mbs-checkbox>
                      @if (canSendNetwork) {
                        <mbs-checkbox
                          formControlName="includeNetworkDiagnostics"
                          [disabledSelf]="!formGroup.get('agentCommands.backup').value"
                          [label]="'shared:sendLogs.label.includeNetwork' | i18next: { format: 'capitalize' }"></mbs-checkbox>
                      }
                    </mbs-form-group>
                  }
                </div>
              </div>
            </mbs-form-group>
          }
        </div>

        <!-- Middle Block -->
        @if (canSendDatabase || canSendMemoryDumps) {
          <div
            class="py-3 border-top border-bottom"
            id="middle-block">
            <mbs-accordion
              #buildAccordion
              [align]="'left'"
              [arrow]="false"
              [narrowHeader]="true"
              [size]="'large'"
              [withoutBorder]="true">
              <mbs-accordion-panel [id]="'checkboxesPanel'">
                <ng-container panelTitle>
                  <span class="row px-4">
                    <span class="col">{{ 'shared:sendLogs.title.optionsForSupportTeam' | i18next }}</span>
                    <span class="col-auto">
                      <i
                        aria-hidden="true"
                        class="ml-2 fa"
                        [class.fa-chevron-down]="buildAccordion.isExpanded('checkboxesPanel')"
                        [class.fa-chevron-right]="!buildAccordion.isExpanded('checkboxesPanel')"></i>
                    </span>
                  </span>
                </ng-container>
                <div class="mb-2 text-base">{{ 'shared:sendLogs.descriptions.optionsForSupportTeam' | i18next }}</div>
                @if (canSendDatabase || canSendMemoryDumps || canSendDestinationListing) {
                  <mbs-form-group class="mb-0">
                    @if (canSendDatabase) {
                      <mbs-checkbox
                        formControlName="includeDatabase"
                        [disabledSelf]="!formGroup.get('agentCommands.backup').value"
                        [label]="'shared:sendLogs.label.includeDatabase' | i18next: { format: 'capitalize' }"
                        [labelClasses]="'text-base'">
                      </mbs-checkbox>
                    }
                    @if (canSendMemoryDumps) {
                      <mbs-checkbox
                        formControlName="includeMemoryDumps"
                        [disabledSelf]="!formGroup.get('agentCommands.backup').value"
                        [label]="'shared:sendLogs.label.includeMemoryDumps' | i18next: { format: 'capitalize' }"
                        [labelClasses]="'text-base'">
                      </mbs-checkbox>
                    }
                    @if (canSendDestinationListing) {
                      <mbs-checkbox
                        formControlName="includeDestinationListing"
                        [disabledSelf]="!formGroup.get('agentCommands.backup').value"
                        [label]="'shared:sendLogs.label.includeDestinationListing' | i18next: { format: 'capitalize' }"
                        [labelClasses]="'text-base'">
                        <ng-template checkboxDescription>
                          <mbs-select
                            class="pt-2"
                            formControlName="destinationListing"
                            [appendTo]="'.modal-content'"
                            [bindLabel]="'DisplayName'"
                            [clearable]="true"
                            [closeOnSelect]="true"
                            [disabledSelf]="!formGroup.get('includeDestinationListing').value"
                            [isCheckboxOverflow]="true"
                            [isCheckboxSelect]="false"
                            [items]="destinationsByHid()"
                            [multiple]="true"
                            [searchable]="true"
                            [virtualScroll]="true">
                            <ng-template
                              #mbsSelectLabelTmp
                              let-item="item">
                              <span>{{ item?.DisplayName }}</span>
                            </ng-template>
                            <ng-template
                              #mbsSelectOptionTmp
                              let-item="item"
                              let-item$="item$">
                              <div class="form-row flex-nowrap cursor-pointer">
                                <div class="col-auto d-flex align-items-center">
                                  <span class="mbs-storage mbs-storage-sm mbs-storage_{{ item?.StorageType | storageIcon }}"></span>
                                </div>
                                <div class="col text-overflow">
                                  <span>{{ item?.DisplayName }}</span>
                                </div>
                              </div>
                            </ng-template>
                          </mbs-select>
                        </ng-template>
                      </mbs-checkbox>
                    }
                  </mbs-form-group>
                }
              </mbs-accordion-panel>
            </mbs-accordion>
          </div>
        }

        <!-- Bottom Block -->
        <div
          class="p-4"
          id="bottom-block">
          <mbs-form-group>
            <mbs-input
              formControlName="message"
              type="textarea"
              [label]="'shared:sendLogs.label.problemDescription' | i18next: { format: 'capitalize' }"
              [placeholder]="'shared:sendLogs.placeholder.problemDescription' | i18next: { format: 'capitalize' }"
              [rows]="4"
              [trim]="false"></mbs-input>
          </mbs-form-group>

          <mbs-form-group [class.mb-0]="!('SuperAdmin' | can: 'read')">
            <mbs-input
              formControlName="ticket"
              [label]="'shared:sendLogs.label.ticket' | i18next"
              [placeholder]="'shared:sendLogs.placeholder.ticket' | i18next: { format: 'capitalize' }"
              [validationWhitespace]="true"></mbs-input>
          </mbs-form-group>

          @if ('SuperAdmin' | can: 'read') {
            <mbs-form-group class="mb-0">
              <mbs-checkbox
                formControlName="sendToSuperAdmin"
                [label]="'shared:sendLogs.label.toDev' | i18next: { format: 'capitalize' }"></mbs-checkbox>
            </mbs-form-group>
          }
        </div>
      </fieldset>
    </form>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="isDisabled"
      [loading]="loading$ | async"
      (click)="handleResolve()">
      {{ 'shared:buttons.report' | i18next: { format: 'title' } }}
    </mbs-button>

    <mbs-button
      data-dismiss="modal"
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>

<ng-template
  #errorTemplate
  let-context>
  <mbs-table-grid
    bindChildren="childs"
    bindParentKey="hid"
    childHeaderClasses="background-white"
    classesTable="-accordion"
    rowClasses="background-light"
    [collapsibleMode]="true"
    [data]="context.resultList"
    [headers]="headers"
    [height]="'calc(100vh - 8rem - 139px)'"
    [minHeight]="'200px'"
    [multipleSelect]="false"
    [showChildrenHeaders]="false"
    [showHeaders]="false"
    [showNav]="false"
    [stripedTable]="false"
    [subtitleHeaders]="subHeaders"
    [viewMode]="sharedPersistentStateEnum.table">
    <ng-template
      let-error
      mbsTableCell>
      <div class="row align-items-center">
        <div class="col-auto text-center">
          <span class="mbs-table-grid_ico text-primary">
            <i class="fa fa-desktop text-primary"></i>
          </span>
        </div>

        <div class="col">
          <div class="mbs-table-grid_accordion-title">
            {{ error.name || error.displayName }}
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template
      let-error
      mbsTableCell>
      <div class="row justify-content-end">
        <div
          *ngFor="let child of error.childs"
          class="col-auto lh-1">
          <mbs-status
            class="force-update-status-bar"
            [icon]="child.ok ? 'ico ico-success' : 'ico ico-exclamation-circle'"
            [type]="child.ok ? statusType.success : statusType.danger">
            {{ child.agentType }}
          </mbs-status>
        </div>
      </div>
    </ng-template>

    <ng-template
      group="child"
      let-child
      mbsTableCell>
      <div class="force-update-details">
        <div class="fw-semibold mb-1">{{ child.agentType }}</div>

        <div class="form-row">
          <div class="col-auto lh-1">
            <span class="mbs-status">
              <span class="mbs-status_ico -sm fa fa-circle text-{{ child.ok ? 'success' : 'danger' }} mr-0"></span>
            </span>
          </div>

          <div class="col">{{ child.message }}</div>
        </div>
      </div>
    </ng-template>
  </mbs-table-grid>
</ng-template>
